// Finds web addresses (https://…, http://… or www.…) in a step's note so they can be shown as links. A full stop, comma or
// closing bracket right after an address is treated as part of the sentence, not the address.
export type Part = { text: string; url?: string };

const ADDRESS = /(?:https?:\/\/|www\.)[^\s<>"]+/gi;

export function linkify(text: string): Part[] {
  const parts: Part[] = [];
  let at = 0;
  for (const m of text.matchAll(ADDRESS)) {
    let found = m[0];
    const trail = /[.,;:!?)\]]+$/.exec(found);
    if (trail && !(trail[0].startsWith(')') && found.includes('('))) found = found.slice(0, -trail[0].length);
    if (!found || /^(?:https?:\/\/|www\.)$/i.test(found)) continue;
    if (m.index! > at) parts.push({ text: text.slice(at, m.index) });
    parts.push({ text: found, url: /^https?:\/\//i.test(found) ? found : `https://${found}` });
    at = m.index! + found.length;
  }
  if (at < text.length) parts.push({ text: text.slice(at) });
  return parts;
}
